/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useReducer, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FieldAutoComplete from "../../shared/controls/fieldAutoComplete";
import FieldCheckBox from "../../shared/controls/fieldCheckBox";
import FieldTextBox from "../../shared/controls/fieldTextBox";
import FieldDropDown from "../../shared/controls/fieldDropDown";
import constantes from "../../catalogos/constantes";
import { TabPanel, TabView } from "primereact/tabview";
import CTPAT from "./secciones/ctpat";
import EPP from "./secciones/epp";
import formReducer from "../../shared/forms/formReducer";
import FormHandler from "../../shared/forms/formHandler";
import useApiPatios from "../../api/operaciones/useApiPatios";
import Inspeccion from "./secciones/inspeccion";
import imagenesUnidades from "./secciones/imagenesUnidades";
import InspeccionLlanta from "./secciones/inspeccionLlanta";
import ButtonIcon from "../../shared/controls/ButtonIcon";
import alerts from "../../shared/alerts";
import controlPatioValidacionEsquema from "./controlPatioValidacionEsquema";
import { isTablet } from "react-device-detect";
import TableCheckListUnidad from "./checkListUnidades/tableCheckListUnidad";
import FieldInputNumber from "../../shared/controls/fieldInputNumber";
import { useEmpresa } from "../../layout/EmpresaProvider";
import FieldCamera from "../../shared/controls/fieldCamera";
import { Dialog } from "primereact/dialog";
import Compress from "compress.js";
import ImageViewer from "../../shared/componentes/imageViewer";
import useOfflineApi from "../../shared/offlineApi/useOfflineApi";
import { useLoadingDispatch } from "../../layout/show-loading-context";
import { useAuth } from "../../Seguridad/AuthProvider";
import moment from "moment";

const ControlPatioDetalle = () => {
  const history = useNavigate();
  const { user } = useAuth();
  let { id, salida } = useParams();

  const esSalida = salida === "1";

  const [visibleModal, setVisibleModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [vistaPrevia, setVistaPrevia] = useState(false);
  const [datosPatios, setDatosPatio] = useState([]);
  const [guardando, setGuardando] = useState(false);
  const api = useApiPatios();
  const { empresaId, disable: disableEmpresa } = useEmpresa();
  const comprimir = new Compress();
  const loadingDispatch = useLoadingDispatch();
  const usuarioId = user.username;
  const { pushCall } = useOfflineApi();

  const defaultSolicitudServicio = () => ({
    entity: {
      id: 0,
      conCaja: true,
      esPermisionario: false,
      verificacionSelloFiscal: null,
      estadoSelloFiscal: null,
      selloFiscal: "",
      selloFiscalNuevo: "",
      solicitudesServicio: [],
    },
  });
  const opcionesEstadoSelloFiscal = [
    {
      id: "nuevo",
      nombre: "Nuevo",
    },
    {
      id: "danado",
      nombre: "Dañado",
    },
    {
      id: "otro",
      nombre: "Otro",
    },
  ];
  const [{ entity, errors, submitted, ...state }, dispatch] = useReducer(
    formReducer,
    {},
    defaultSolicitudServicio,
  );
  const esUnidadUtilitaria =
    Number(entity?.unidad?.tipoUnidadId) === constantes.tiposUnidad.Utilitario;

  const formHandler = new FormHandler({
    validationSchema: controlPatioValidacionEsquema.salida,
    api: api,
    dispatch,
  });

  useEffect(() => {
    async function cargar() {
      if (esSalida && id !== "0") {
        await api.actualizarLlantas(id);
      }

      const patios = await api.obtenerPatios({
        usuarioId,
      });

      setDatosPatio(patios);

      const controlPatios = await api.obtener(id);

      const datosUnidad = controlPatios?.unidad?.id
        ? await api.unidadAveriasyLLantas(controlPatios.unidad.id)
        : null;

      const datosRemolque = controlPatios?.caja?.id
        ? await api.unidadAveriasyLLantas(controlPatios.caja.id)
        : null;

      const selloFiscalConsultado = await cargarSelloFiscal(controlPatios);

      const selloFiscalAnterior =
        selloFiscalConsultado || controlPatios.selloFiscal || "";

      dispatch({
        type: "update",
        value: {
          ...controlPatios,

          averiasUnidad:
            datosUnidad?.averias ?? controlPatios.averiasUnidad ?? [],

          llantasUnidad:
            controlPatios?.llantasUnidad?.length > 0
              ? controlPatios.llantasUnidad
              : (datosUnidad?.llantas ?? []),

          llantasRemolque:
            controlPatios?.llantasRemolque?.length > 0
              ? controlPatios.llantasRemolque
              : (datosRemolque?.llantas ?? []),
          averiasRemolque:
            datosRemolque?.averias ?? controlPatios.averiasRemolque ?? [],

          selloFiscal: selloFiscalAnterior,

          selloFiscalNuevo:
            controlPatios.selloFiscalNuevo || selloFiscalAnterior,
        },
      });

      if (controlPatios?.unidad?.id) {
        await obtenerSolicitudServicio(controlPatios.unidad);
      }
    }

    cargar().then();
    disableEmpresa();
  }, []);

  useEffect(() => {
    if (submitted) formHandler.validate(entity);
  }, [entity]);

  async function actualizar(value, propertyName) {
    if (propertyName === "archivo") {
      let file = await resizeImageFn(value);
      const result = await api.guardarBitacora(entity.id, file);

      dispatch({ type: "update", value: true, name: "bitacora" });

      file.file = null;
      file.url = result.fileUrl;

      dispatch({ type: "update", value: file, name: propertyName });
      setVisibleModal(false);
    } else {
      dispatch({ type: "update", value: value, name: propertyName });
      const omitirSello =
        (propertyName === "conCaja" && value === false) ||
        (propertyName === "unidadCargada" && value === false);

      if (omitirSello) {
        dispatch({
          type: "update",
          value: null,
          name: "verificacionSelloFiscal",
        });
        dispatch({ type: "update", value: null, name: "estadoSelloFiscal" });
        dispatch({ type: "update", value: "", name: "selloFiscal" });
        dispatch({ type: "update", value: "", name: "selloFiscalNuevo" });
      }
      if (value === true && propertyName === "esPermisionario") {
        actualizar(null, "unidad");
      }

      if (value === true && propertyName === "esExterno") {
        actualizar(null, "caja");
        dispatch({ type: "update", value: value, name: "esExterno" });
      }

      if (value !== null && propertyName === "nombreCaja") {
        var llantas = [];

        for (var i = 11; i <= 18; i++) {
          var element = {
            id: 0,
            idCautin: "",
            idCautinOriginal: i,
            posicion: i,
            requerido: false,
          };

          llantas.push(element);
        }

        actualizar(llantas, "llantasRemolque");
      }
    }
  }

  async function obtenerSolicitudServicio(unidad) {
    if (!unidad?.id) {
      dispatch({
        type: "update",
        name: "solicitudesServicio",
        value: [],
      });

      return;
    }

    const solicitudes = await api.obtenerSolicitudServicio(unidad.id);

    dispatch({
      type: "update",
      name: "solicitudesServicio",
      value: solicitudes ?? [],
    });
  }

  async function cargarSelloFiscal(controlPatios) {
    if (!controlPatios?.conCaja) {
      return "";
    }

    if (controlPatios.esExterno) {
      return controlPatios.nombreCaja
        ? await api.obtenerSelloFiscalExterno(controlPatios.nombreCaja)
        : "";
    }

    return controlPatios.caja?.id
      ? await api.obtenerSelloFiscal(controlPatios.caja.id)
      : "";
  }

  async function cambioUnidad(value, propertyName) {
    actualizar(value, propertyName);

    if (value?.puedeLlevarCaja === false && propertyName === "unidad") {
      actualizar(false, "conCaja");
    }

    const datosEquipo =
      value != null
        ? await api.unidadAveriasyLLantas(value.id)
        : {
            averias: [],
            llantas: [],
          };

    const averiasEquipo = Array.isArray(datosEquipo?.averias)
      ? datosEquipo.averias
      : [];

    const llantasEquipo = Array.isArray(datosEquipo?.llantas)
      ? datosEquipo.llantas
      : [];

    actualizar(
      averiasEquipo,
      propertyName === "unidad" ? "averiasUnidad" : "averiasRemolque",
    );

    actualizar(
      llantasEquipo,
      propertyName === "unidad" ? "llantasUnidad" : "llantasRemolque",
    );

    if (propertyName === "unidad" && !esSalida) {
      const check = value != null ? await api.obtenerInformacion(value.id) : [];

      actualizar(check, "checkList");
    }

    if (propertyName === "unidad" && esSalida && id === "0" && value != null) {
      const salidaId = await api.obtenerSalidaPorUnidad(value.id);

      await api.actualizarLlantas(salidaId);

      const controlPatios = await api.obtener(salidaId);

      let datosRemolque = {
        averias: controlPatios?.averiasRemolque ?? [],
        llantas: controlPatios?.llantasRemolque ?? [],
      };

      if (controlPatios?.caja?.id) {
        const resultadoRemolque = await api.unidadAveriasyLLantas(
          controlPatios.caja.id,
        );

        datosRemolque = {
          averias: Array.isArray(resultadoRemolque?.averias)
            ? resultadoRemolque.averias
            : [],
          llantas: Array.isArray(resultadoRemolque?.llantas)
            ? resultadoRemolque.llantas
            : [],
        };
      }

      const selloFiscalConsultado = await cargarSelloFiscal(controlPatios);

      const selloFiscalAnterior =
        selloFiscalConsultado || controlPatios.selloFiscal || "";

      dispatch({
        type: "update",
        value: {
          ...controlPatios,

          averiasUnidad: averiasEquipo,
          llantasUnidad: llantasEquipo,

          averiasRemolque: datosRemolque.averias,
          llantasRemolque: datosRemolque.llantas,

          selloFiscal: selloFiscalAnterior,
          selloFiscalNuevo:
            controlPatios.selloFiscalNuevo || selloFiscalAnterior,
        },
      });

      if (controlPatios?.unidad?.id) {
        await obtenerSolicitudServicio(controlPatios.unidad);
      }

      history(`/controlDePatios/salida/1/${salidaId}`);

      return;
    }

    if (propertyName === "unidad") {
      actualizar(value?.placas ?? "", "placas");
      await obtenerSolicitudServicio(value);
    }

    if (propertyName === "caja") {
      actualizar(value?.placasRem ?? "", "placasRem");

      actualizar(null, "verificacionSelloFiscal");

      actualizar(null, "estadoSelloFiscal");

      const selloFiscal = value?.id
        ? await api.obtenerSelloFiscal(value.id)
        : "";

      actualizar(selloFiscal ?? "", "selloFiscal");

      actualizar(selloFiscal ?? "", "selloFiscalNuevo");
    }
  }

  function tabLlantasDesactivadas() {
    return entity.unidad == null && entity.nombreUnidad === null;
  }

  function tabAccesoriosDesactivadas() {
    return (
      entity.checkList == null ||
      entity.checkList.length === 0 ||
      entity.checkList[0].checkList.length === 0
    );
  }
  const regresarConNotificacion = (message, severity = "success") => {
    history("/controlDePatios");

    window.setTimeout(() => {
      loadingDispatch({
        type: "toast",
        message,
        severity,
      });
    }, 150);
  };

  const guardar = async () => {
    if (guardando) {
      return;
    }

    setGuardando(true);

    try {
      if (esSalida && entity?.bitacoras > 0 && !entity?.bitacora) {
        await alerts.aviso(
          "Es necesario verificar si el operador lleva su bitácora de viaje.",
        );

        return;
      }

      const requiereSelloFiscal =
        entity.conCaja === true && entity.unidadCargada !== false;

      const entityGuardar = {
        ...entity,
        inspeccionUnidad: esUnidadUtilitaria
          ? []
          : (entity.inspeccionUnidad ?? []),

        inspeccionCabina: Array.isArray(entity.inspeccionCabina)
          ? entity.inspeccionCabina.filter(
              (item) =>
                item.necesitaServicio != null && item.necesitaServicio !== -1,
            )
          : [],

        epp: Array.isArray(entity.epp)
          ? entity.epp.filter(
              (item) =>
                item.necesitaServicio != null && item.necesitaServicio !== -1,
            )
          : [],

        inspeccionRemolque:
          entity.conCaja === true ? (entity.inspeccionRemolque ?? []) : [],
        selloFiscal: requiereSelloFiscal ? (entity.selloFiscal ?? "") : "",

        verificacionSelloFiscal: requiereSelloFiscal
          ? entity.verificacionSelloFiscal
          : null,

        estadoSelloFiscal:
          requiereSelloFiscal && entity.verificacionSelloFiscal === false
            ? entity.estadoSelloFiscal
            : null,

        selloFiscalNuevo:
          requiereSelloFiscal && entity.verificacionSelloFiscal === true
            ? entity.selloFiscal || entity.selloFiscalNuevo || ""
            : requiereSelloFiscal &&
                entity.verificacionSelloFiscal === false &&
                entity.estadoSelloFiscal
              ? entity.selloFiscalNuevo || ""
              : null,

        llantasUnidad: Array.isArray(entity.llantasUnidad)
          ? entity.llantasUnidad.map((llanta) => ({
              ...llanta,

              llantaDanada: llanta.llantaDanada === true,

              revisarCautin: llanta.revisarCautin === true,

              sinCautinSeleccionado: llanta.sinCautinSeleccionado === true,
            }))
          : [],

        llantasRemolque:
          entity.conCaja === true && Array.isArray(entity.llantasRemolque)
            ? entity.llantasRemolque.map((llanta) => ({
                ...llanta,

                llantaDanada: llanta.llantaDanada === true,

                revisarCautin: llanta.revisarCautin === true,

                sinCautinSeleccionado: llanta.sinCautinSeleccionado === true,
              }))
            : [],
      };

      await formHandler.validateSubmit(entityGuardar);

      if (!formHandler.valdation.result) {
        return;
      }

      const apiUrl = esSalida
        ? entityGuardar.id > 0
          ? `/operaciones/controlPatios/${entityGuardar.id}`
          : "/operaciones/controlPatios/salida"
        : "/operaciones/controlPatios/acceso";

      await pushCall(entityGuardar, apiUrl);

      regresarConNotificacion(
        "La solicitud fue enviada correctamente",
        "success",
      );
    } catch (error) {
      console.error("Error al registrar la solicitud:", error);

      regresarConNotificacion(
        error?.message || "No se pudo registrar la solicitud.",
        "error",
      );
    } finally {
      setGuardando(false);
    }
  };
  function unidadDesactivada(averias, llantas) {
    return (
      esSalida ||
      !entity.editable ||
      averias?.findIndex((e) => e.editable === true) >= 0 ||
      llantas?.findIndex(
        (e) => e.idCautin.length > 0 && e.idCautinOriginal.length,
      ) >= 0
    );
  }

  function unidadBusqueda(averias, llantas) {
    if (esSalida && id === "0") return false;

    return unidadDesactivada(averias, llantas);
  }

  async function back() {
    if (!state.isDirty || (await alerts.preguntarSiDeseaSalirSinGuardar())) {
      history(-1);
    }
  }

  function errorCtpat() {
    return (
      errors?.inspeccionUnidad ||
      errors?.inspeccionRemolque ||
      errors?.medidasExternas ||
      errors?.medidasInternas ||
      errors?.tamanioRemolque
    );
  }

  function errorLlantas() {
    return errors?.llantasUnidad || errors?.llantasRemolque;
  }

  function errorCheckList() {
    return errors?.checkList;
  }

  async function resizeImageFn(file) {
    var imageData = file.file.toString();

    var byteCharacters = atob(
      imageData.replace(/^data:image\/(png|jpeg|jpg);base64,/, ""),
    );

    var byteNumbers = new Array(byteCharacters.length);

    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    var blob = new Blob([byteArray], {
      type: "image/png",
    });

    const resizedImage = await comprimir.compress([blob], {
      size: 2,
      quality: 0.6,
      maxWidth: 500,
      maxHeight: 300,
      resize: true,
    });

    const img = resizedImage[0];

    var data =
      "data:image/png;base64," +
      img.data.replace(/^data:image\/(png|jpeg|jpg);base64,/, "");

    return {
      file: data,
      url: data,
      isEmpty: false,
      nombre: "foto.jpg",
      isBase64: true,
      extension: "png",
    };
  }

  function eliminarfoto() {
    dispatch({ type: "update", value: false, name: "bitacora" });
    dispatch({ type: "update", value: null, name: "archivo" });
  }

  return (
    <>
      <div className={`form-filtro form-row`}>
        {entity.nombreUnidad != null && esSalida && !entity.editable ? (
          <FieldTextBox
            label="No. Económico"
            colMd={2}
            value={entity.nombreUnidad}
            disabled
          />
        ) : (
          <>
            {entity.esPermisionario === false ? (
              <>
                <FieldAutoComplete
                  name="unidad"
                  source="unidades"
                  label="No. Económico"
                  required
                  disabled={unidadBusqueda(
                    entity.averiasUnidad,
                    entity.llantasUnidad,
                  )}
                  params={{
                    todasLasEmpresas: true,
                    id: constantes.tiposEquipo.motriz,
                  }}
                  colMd={2}
                  value={entity.unidad}
                  onChange={cambioUnidad}
                  errors={errors}
                />

                <FieldTextBox
                  disabled={true}
                  label="*Placas"
                  errors={errors}
                  name="placas"
                  onChange={actualizar}
                  colMd={2}
                  value={entity.placas}
                />

                <div
                  style={{ marginRight: "-25px" }}
                  className={`form-group col-md-${
                    isTablet ? "3" : "2"
                  } col-sm-4`}
                >
                  <label>Verificación Placas Unidad</label>

                  <FieldCheckBox
                    name="verificacionPlacasUnidad"
                    isRadioButton={true}
                    yesOption={"Si"}
                    noOption={"No"}
                    value={entity.verificacionPlacasUnidad}
                    onChange={actualizar}
                    errors={errors}
                  />
                </div>
              </>
            ) : (
              <FieldTextBox
                disabled={!entity.editable}
                label="*No. Económico"
                errors={errors}
                name="nombreUnidad"
                onChange={actualizar}
                colMd={2}
                value={entity.nombreUnidad}
              />
            )}

            <FieldCheckBox
              colMd={1}
              disabled={!entity.editable || esSalida}
              label="Permisionario"
              name="esPermisionario"
              value={entity.esPermisionario}
              onChange={actualizar}
            />
          </>
        )}

        <FieldDropDown
          name="patioUbicacion"
          label="Ubicacion"
          colMd={2}
          filter={true}
          options={datosPatios.patioUbicacion}
          required
          errors={errors}
          value={entity.patioUbicacion}
          onChange={actualizar}
        />

        <FieldCheckBox
          colMd={1}
          disabled={!entity.editable}
          label="Vidrio Polarizado"
          name="esVidrioPolarizado"
          value={entity.esVidrioPolarizado}
          onChange={actualizar}
        />

        {entity.conCaja && (
          <>
            {entity.nombreCaja != null &&
            esSalida &&
            !entity.editable &&
            !entity.editablePermiso ? (
              <FieldTextBox
                label="No. Remolque"
                colMd={2}
                value={entity.nombreCaja}
                disabled
              />
            ) : (
              <>
                {entity.esExterno === false ? (
                  <>
                    <FieldAutoComplete
                      name="caja"
                      source="unidades"
                      label="No. Remolque"
                      required
                      disabled={
                        !entity?.editablePermiso &&
                        unidadDesactivada(
                          entity.averiasRemolque,
                          entity.llantasRemolque,
                        )
                      }
                      params={{
                        todasLasEmpresas: true,
                        id: constantes.tiposEquipo.arrastre,
                      }}
                      colMd={2}
                      value={entity.caja}
                      onChange={cambioUnidad}
                      errors={errors}
                    />

                    <FieldTextBox
                      disabled={true}
                      label="*Placas"
                      errors={errors}
                      name="placasRem"
                      onChange={actualizar}
                      colMd={2}
                      value={entity.placasRem}
                    />
                  </>
                ) : (
                  <FieldTextBox
                    disabled={
                      !entity?.editablePermiso &&
                      (!entity?.editable || esSalida)
                    }
                    label="*No. Remolque"
                    errors={errors}
                    name="nombreCaja"
                    onChange={actualizar}
                    colMd={2}
                    value={entity.nombreCaja}
                  />
                )}

                <FieldCheckBox
                  disabled={
                    !entity?.editablePermiso && (!entity.editable || esSalida)
                  }
                  colMd={1}
                  label="Externo"
                  name="esExterno"
                  value={entity.esExterno}
                  onChange={actualizar}
                />
              </>
            )}
          </>
        )}

        <div
          style={{ marginRight: "-25px" }}
          className={`form-group col-md-${isTablet ? "2" : "2"} col-sm-4`}
        >
          <label>Verificación Placas Remolque</label>

          <FieldCheckBox
            name="verificacionPlacas"
            isRadioButton={true}
            yesOption={"Si"}
            noOption={"No"}
            value={entity.verificacionPlacas}
            onChange={actualizar}
            errors={errors}
          />
        </div>

        {entity.conCaja === true && entity.unidadCargada !== false && (
          <>
            <div className="form-group col-md-2 col-sm-4">
              <label>¿El sello fiscal es correcto?</label>

              <FieldCheckBox
                name="verificacionSelloFiscal"
                isRadioButton={true}
                yesOption="Sí"
                noOption="No"
                value={entity.verificacionSelloFiscal}
                errors={errors}
                onChange={(value) => {
                  actualizar(value, "verificacionSelloFiscal");
                  actualizar(null, "estadoSelloFiscal");

                  if (value === true) {
                    actualizar(
                      entity.selloFiscal || entity.selloFiscalNuevo || "",
                      "selloFiscalNuevo",
                    );
                  } else {
                    actualizar("", "selloFiscalNuevo");
                  }
                }}
              />
            </div>

            {entity.verificacionSelloFiscal === false && (
              <FieldDropDown
                name="estadoSelloFiscal"
                label="Estado del sello fiscal"
                colMd={2}
                colMob={3}
                required
                options={opcionesEstadoSelloFiscal}
                value={
                  opcionesEstadoSelloFiscal.find(
                    (opcion) => opcion.id === entity.estadoSelloFiscal,
                  ) ?? null
                }
                disabled={!entity.editable && !entity.editablePermiso}
                filter={false}
                errors={errors}
                onChange={(opcion) => {
                  const estado = opcion?.id ?? null;

                  actualizar(estado, "estadoSelloFiscal");

                  if (estado && !entity.selloFiscalNuevo) {
                    actualizar(entity.selloFiscal || "", "selloFiscalNuevo");
                  }
                }}
              />
            )}

            <FieldTextBox
              name="selloFiscalNuevo"
              label="Sello Fiscal"
              colMd={2}
              value={entity.selloFiscalNuevo ?? ""}
              disabled={
                entity.verificacionSelloFiscal !== false ||
                !entity.estadoSelloFiscal ||
                (!entity.editable && !entity.editablePermiso)
              }
              onChange={actualizar}
              errors={errors}
              required={
                entity.verificacionSelloFiscal === true ||
                Boolean(entity.estadoSelloFiscal)
              }
            />
          </>
        )}

        <div
          style={{ marginRight: "-25px" }}
          className={`form-group col-md-${isTablet ? "3" : "2"} col-sm-6`}
        >
          <label />

          <FieldCheckBox
            name="conCaja"
            isRadioButton={true}
            disabled={
              !entity?.editablePermiso &&
              (!entity.editable ||
                esSalida ||
                entity.unidad?.puedeLlevarCaja === false)
            }
            yesOption={"Con remolque"}
            noOption={"Sin remolque"}
            value={entity.conCaja}
            onChange={actualizar}
          />
        </div>

        <div className="field-iconos btn-group">
          <ButtonIcon
            title="Regresar"
            iconName={"BiArrowBack"}
            onClick={back}
          />

          {(entity.editable || entity.editablePermiso) && (
            <ButtonIcon
              title={guardando ? "Guardando..." : "Guardar"}
              className="action"
              iconName="FaCheckCircle"
              disabled={guardando}
              onClick={guardar}
            />
          )}
        </div>
      </div>

      <div className={`form-row`}>
        {/*(entity.conCaja || entity.unidad?.puedeLlevarCaja === false) && (
          <FieldTextBox
            name="selloABC"
            label="Sello ABC"
            colMd={2}
            required
            disabled={!entity.editable}
            value={entity.selloABC}
            onChange={actualizar}
          />
        )*/}

        <FieldTextBox
          maxLength={600}
          disabled={!entity.editable && !entity.editablePermiso}
          label="Comentarios"
          name="comentarios"
          onChange={actualizar}
          colMd={6}
          value={entity.comentarios ?? ""}
        />

        <FieldInputNumber
          label="Odometro"
          name="odometro"
          value={entity.odometro}
          disabled={!entity.editable}
          colMd={2}
          errors={errors}
          onChange={actualizar}
        />

        {entity?.bitacoras > 0 && (
          <>
            <FieldCheckBox
              colMd={1}
              disabled={true}
              label={"Bitacora de Viaje"}
              name={"bitacora"}
              value={entity?.bitacora}
              onChange={actualizar}
            />

            {entity.archivo === null ? (
              <div
                className={`text-center ${errors != null ? "error" : ""}`}
                onClick={() => setVisibleModal(true)}
              >
                <img
                  width={"38%"}
                  src={`../../../img/camera.png`}
                  alt="camera"
                />
                <div>Agregar Foto</div>
              </div>
            ) : (
              <div className="d-flex" style={{ alignItems: "center" }}>
                {entity.editable && (
                  <ButtonIcon
                    title={"Eliminar"}
                    onClick={eliminarfoto}
                    iconName={"RiDeleteBinLine"}
                  />
                )}

                <ButtonIcon
                  title={"Visualizar"}
                  onClick={() => setVistaPrevia(true)}
                  iconName="GrFormView"
                />
              </div>
            )}
          </>
        )}
      </div>

      <div className={`form-row`}>
        {entity.operadorExterno ? (
          <FieldTextBox
            name="nombreOperador"
            label="Nombre Operador"
            maxLength={800}
            colMd={3}
            required
            disabled={!entity?.editable && !entity?.editablePermiso}
            upperCase
            value={entity.nombreOperador}
            onChange={actualizar}
            errors={errors}
          />
        ) : (
          <FieldDropDown
            name="operador"
            disabled={!entity?.editable && !entity?.editablePermiso}
            source="empleados"
            params={{
              todasLasEmpresas: true,
              puestoIds: [constantes.puestos.operador],
            }}
            filter={true}
            required
            label="Operador"
            colMd={2}
            colMob={4}
            value={entity.operador}
            onChange={actualizar}
            errors={errors}
          />
        )}

        <FieldCheckBox
          disabled={!entity?.editable && !entity?.editablePermiso}
          colMd={1}
          label="Operador Externo"
          name="operadorExterno"
          value={entity.operadorExterno}
          onChange={actualizar}
        />

        <FieldDropDown
          name="vigilante"
          disabled={!entity.editable}
          source="empleados"
          params={{
            todasLasEmpresas: true,
            puestoIds: [constantes.puestos.guardiaSeguridad],
          }}
          filter={true}
          required
          label="Vigilante"
          colMd={2}
          colMob={4}
          value={entity.vigilante}
          onChange={actualizar}
          errors={errors}
        />

        {!entity?.editablePermiso && esSalida ? (
          <>
            <FieldTextBox
              name="cliente"
              label="Cliente"
              colMd={2}
              value={entity.cliente?.nombre}
              disabled
            />

            <FieldTextBox
              name="Planta"
              label="Planta"
              colMd={2}
              value={entity.plantaDestino}
              disabled
            />

            <FieldTextBox
              name="Solicitante"
              label="Solicitante"
              colMd={2}
              value={entity.nombreSolicitante}
              disabled
            />
          </>
        ) : (
          <FieldTextBox
            name="origen"
            label="Origen"
            colMd={2}
            required={!esSalida}
            value={entity.origen ?? ""}
            onChange={actualizar}
            disabled={!entity.editable && !entity.editablePermiso}
            errors={errors}
          />
        )}

        {entity.conCaja && !entity.esExterno && (
          <div
            style={{ marginRight: "-25px" }}
            className={`form-group col-md-${isTablet ? "3" : "2"} col-sm-6`}
          >
            <label>Caja</label>

            <FieldCheckBox
              name="unidadCargada"
              isRadioButton={true}
              yesOption={"Cargada"}
              noOption={"Vacía"}
              value={entity.unidadCargada}
              onChange={actualizar}
              errors={errors}
            />
          </div>
        )}
      </div>

      <div className="section-container">
        <div className="flex-col-12 minheight">
          <h5>Solicitudes de Servicio</h5>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "10px",
              fontWeight: "bold",
            }}
          >
            <span
              style={{
                width: "14px",
                height: "14px",
                borderRadius: "50%",
                display: "inline-block",
                backgroundColor:
                  Array.isArray(entity?.solicitudesServicio) &&
                  entity.solicitudesServicio.length > 0
                    ? "#28a745"
                    : "#dc3545",
              }}
            />

            <span>
              {Array.isArray(entity?.solicitudesServicio) &&
              entity.solicitudesServicio.length > 0
                ? "Tiene solicitudes de servicio"
                : "No tiene solicitudes de servicio"}
            </span>
          </div>

          <div className="form-row">
            <table className="table text-center">
              <thead className="thead-light">
                <tr>
                  <th
                    scope="col"
                    className="text-center align-middle"
                    style={{ width: "15%" }}
                  >
                    Solicitud Servicio
                  </th>

                  <th
                    scope="col"
                    className="text-center align-middle"
                    style={{ width: "20%" }}
                  >
                    Fecha solicitante
                  </th>

                  <th
                    scope="col"
                    className="text-center align-middle"
                    style={{ width: "30%" }}
                  >
                    Nombre solicitante
                  </th>

                  <th
                    scope="col"
                    className="text-center align-middle"
                    style={{ width: "35%" }}
                  >
                    Descripción
                  </th>
                </tr>
              </thead>

              <tbody>
                {!Array.isArray(entity?.solicitudesServicio) ||
                entity.solicitudesServicio.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="text-center align-middle">
                      Sin solicitudes de servicio para esta unidad.
                    </td>
                  </tr>
                ) : (
                  entity.solicitudesServicio.map((v, index) => (
                    <tr key={v.id || index}>
                      <td className="text-center align-middle">{v.codigo}</td>

                      <td className="text-center align-middle">
                        {v.fechaSolicitud
                          ? moment(v.fechaSolicitud).format(
                              "YYYY-MM-DD HH:mm:00",
                            )
                          : ""}
                      </td>

                      <td className="text-center align-middle">
                        {v.solicitante?.nombre ?? v.nombreSolicitante ?? ""}
                      </td>

                      <td className="text-center align-middle">
                        {v.descripcion}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <fieldset disabled={!entity.editable}>
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          className="main-tab-view"
        >
          {!esUnidadUtilitaria && (
            <TabPanel
              header="C-TPAT"
              rightIcon={errorCtpat() ? "pi pi-exclamation-circle" : ""}
            >
              <CTPAT actualizar={actualizar} entity={entity} errors={errors} />
            </TabPanel>
          )}

          <TabPanel
            header="EPP"
            rightIcon={errorCtpat() ? "pi pi-exclamation-circle" : ""}
          >
            <EPP actualizar={actualizar} entity={entity} errors={errors} />
          </TabPanel>

          <TabPanel header="UNIDAD" disabled={entity.unidad == null}>
            <Inspeccion
              value={entity.averiasUnidad}
              name={"averiasUnidad"}
              onChange={actualizar}
              imagenes={imagenesUnidades.motriz}
              tipoUnidadId={entity.unidad?.tipoUnidadId}
              disabled={!entity.editable}
            />
          </TabPanel>

          <TabPanel
            header="REMOLQUE"
            headerStyle={{ display: entity.conCaja ? "" : "none" }}
            disabled={entity.caja == null && !entity.esExterno}
          >
            <Inspeccion
              value={entity.averiasRemolque}
              name={"averiasRemolque"}
              onChange={actualizar}
              imagenes={imagenesUnidades.arrastre}
              tipoUnidadId={entity.caja?.tipoUnidadId}
              disabled={!entity.editable}
              entity={entity}
            />
          </TabPanel>

          <TabPanel
            header="LLANTAS"
            disabled={tabLlantasDesactivadas()}
            rightIcon={errorLlantas() ? "pi pi-exclamation-circle" : ""}
          >
            <InspeccionLlanta
              editable={entity.editable}
              entity={entity}
              actualizar={actualizar}
              errors={errors}
              tipoUnidadId={entity.unidad?.tipoUnidadId}
            />
          </TabPanel>

          <TabPanel
            rightIcon={errorCheckList() ? "pi pi-exclamation-circle" : ""}
            disabled={tabAccesoriosDesactivadas()}
            header="ACCESORIOS"
          >
            <TableCheckListUnidad
              errors={errors}
              ocultarHeader={true}
              disabled={
                (!entity.editable && !esSalida) ||
                (!entity.editable && esSalida)
              }
              onChange={actualizar}
              checklist={entity.checkList}
            />
          </TabPanel>
        </TabView>
      </fieldset>

      <Dialog
        header="Tomar Fotografia"
        visible={visibleModal}
        onHide={() => setVisibleModal(false)}
      >
        <FieldCamera
          value={entity?.archivo}
          name="archivo"
          useCamera={visibleModal}
          onChange={actualizar}
        />
      </Dialog>

      <ImageViewer
        header={"Bitacora"}
        name="foto"
        value={entity?.archivo}
        onChange={null}
        visible={vistaPrevia}
        hide={() => setVistaPrevia(false)}
        urlApi={`archivos/vistaPrevia/${empresaId}?url=${entity?.archivo?.url}`}
      />
    </>
  );
};

export default ControlPatioDetalle;
